import { render, staticRenderFns } from "./Brightness.vue?vue&type=template&id=05180e41&"
import script from "./Brightness.vue?vue&type=script&lang=ts&"
export * from "./Brightness.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports